<script>
import StoreSearchResultsTabList from '@phoenix/mixins/components/store/StoreSearchResultsTabList';

export default {
  mixins: [StoreSearchResultsTabList],
};
</script>

<template>
  <ul class="flex-grid flex-grid--center flex-grid--y--md flex-grid--x--md">
    <li v-for="store in stores" :key="store.id" class="w-full sm:w-3/4 md:w-1/2 lg:w-1/3">
      <store-card
        :address="store.fullAddress"
        :image="store.rokkaImg"
        :title="store.name"
        :status="store.status"
        :phone="store.phone"
        :permalink="store.permalink"
        :product-categories="store.productCategories"
        :is-online="store.isOnline"
        :see-more-label="store.seeMoreLabel"
        :social-links="store.socialLinks"
        :is-reseller="store.isReseller"
      />
    </li>
  </ul>
</template>
